<template>
    <div>
        <div name="breadcrumb-layout" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>折旧结果报表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :realComDefFirst="false" :multiSelect="true" :onlyShowRealCom="true" :costFlag="false" :prftFlag="false" :showMgmt="false" :bizDepart="false" :showIncludeSubComs="false" :initIncludeSubComs="false" @notity-change="checkComChange($event)"></swb-popover-org-tree>
        </div>
        <div name="table-list" class="table-layout" v-if="paramMap != null">
            <swb-easy-report-table :confKey="confKey" :configAuto="true" :retailerRealComIds="retailerRealComIds" :reportName="reportName" :reportCode="reportCode" :paramMap="paramMap" :includeSubComs="true" :hideParamKeys="hideParamKeys" :detailComponentUrl="detailComponentUrl" :domHeight="domHeight"></swb-easy-report-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import easyReportApi from '../../api/easyReport'

    import SwbEasyReport from './EasyReport'
    Vue.regist(SwbEasyReport);

    export default {
        name: 'asset-depr-result-report',
        path: '/asset/depr/result/report/get',
        desc: '折旧结果报表',
        data: function () {
            return {
                confKey: 'asset-depr-result-report',
                reportCode: "asset_depr_result_report",
                reportName: '折旧结果报表',
                //
                domHeight: 'auto',
                //
                paramMap: null,
                hideParamKeys: ["cxtRealIdX"],
                detailComponentUrl: null,
                retailerRealComIds: []
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="table-list"] '), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="breadcrumb-layout"], .org-tree-layout'));
            domSizeWatcher.start(500);
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        created: function () {
            let paramMap = {
                show_dataLinks: true
            };
            //
            this.paramMap = Utils.merge({}, paramMap);
        },
        methods: {
            // 实体公司切换
            checkComChange: function (eventDataList) {
                let realComIds = [];
                if(Array.isArray(eventDataList)) {
                    eventDataList = eventDataList || [];
                    for(let i = 0, len = eventDataList.length; i < len; i++) {
                        let eventData = eventDataList[i];
                        if(Utils.isTrue(eventData.realFlag)) {
                            this.realFlag = true;
                            realComIds.push(eventData.id);
                        }
                    }
                } else {
                    let eventData = eventDataList || {};
                    realComIds.push(eventData.id)
                }
                //
                this.retailerRealComIds = Utils.merge([], realComIds);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/AssetDeprResultReport.vue